var $ = jQuery;

// Define the interval and timeout variables
var inter, timeout;

// Function to clear the interval and timeout
function clearChecks() {
  clearInterval(inter);
  clearTimeout(timeout);
  console.log('Stopping checks, elements not found in time.');
}

// Set up the interval to check for elements
inter = setInterval(function() {
  var len = $('.ctm_main_newpdp .ui-accordion-header .ui-tabs-anchor,#custom_product_page .ui-accordion-header .ui-tabs-anchor').length;
  console.log('Checking element presence, count:', len);
  if(len > 0){
    console.log('Elements found, setting up event handlers.');
    clearInterval(inter); // Clear interval if elements are found
    clearTimeout(timeout); // Clear the timeout as well
    // Set up event handlers here
    $('.ctm_main_newpdp .ui-accordion-header .ui-tabs-anchor,#custom_product_page .ui-accordion-header .ui-tabs-anchor').off('click').on('click', function(e) {
      if($(window).width() < 769){
        e.preventDefault();
        var _this = $(this);
        $(this).toggleClass('active_accordion');
        var id = '#' + $(this).closest('h3.ui-accordion-header').attr('aria-controls');
        $(id).slideToggle();
        setTimeout(function() {
          $('html, body').animate({
            scrollTop: _this.offset().top - 100
          }, 800);
        }, 500);
        return false;
      }
    });
  }
}, 100); // Check every 100ms

// Set up a timeout to stop checking after 5 seconds
timeout = setTimeout(clearChecks, 5000);

$(window).on('load', function(e) {
  $('#tabs-app-accordion > h3:first-child a').addClass('active_accordion');
  $('#tabs-app-accordion > h3 a').each(function (e) {
    var text = $(this).text().toLowerCase();
    if(text.indexOf('juices') > -1){
      console.log(text) 
      if(!$(this).hasClass('active_accordion')){
        $(this).addClass('active_accordion');
        var id = '#' + $(this).closest('h3.ui-accordion-header').attr('aria-controls');
        $(id).slideToggle(); 
      }
    } 
  })
})

$(document).ready(function() {
  
  SVGInject(document.querySelectorAll("img.injectable"));

  if($('#best-seller-slider').length > 0) {
    $('#best-seller-slider').slick({
      dots: false, 
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1, 
      arrows: true,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
                   {
                     breakpoint: 992,
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '60px',
                       slidesToShow: 2,
                       slidesToScroll: 1,
                     }
                   },
                   {
                     breakpoint: 768,
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '60px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                     }
                   },
                   {
                     breakpoint: 479, 
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '30px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                     }
                   }
                  ]
    });
  }

  if($('#accessories-seller-slider').length > 0) {
    $('#accessories-seller-slider').slick({
      dots: false, 
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
                   {
                     breakpoint: 992,
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '60px',
                       slidesToShow: 2,
                       slidesToScroll: 1,
                     }
                   },
                   {
                     breakpoint: 768,
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '60px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                     }
                   },
                   {
                     breakpoint: 479, 
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '30px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                     }
                   }
                  ]
    });
  }

  if($('#nutri-media-slider').length > 0) {
    $('#nutri-media-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 768, 
        settings: { 
          slidesToShow: 2, 
          slidesToScroll: 1,
        } 
      },
                   {
                     breakpoint: 992,
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '60px',
                       slidesToShow: 2,
                       slidesToScroll: 1,
                     }
                   },
                   {
                     breakpoint: 768, 
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '60px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                     }
                   },
                   {
                     breakpoint: 479, 
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '30px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                     }
                   }
                  ]
    })
  }

  if($('#review-slider').length > 0) {
    $('#review-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: true,
      arrows: true, 
      responsive: [{
        breakpoint: 768, 
        settings: { 
          slidesToShow: 2, 
          slidesToScroll: 1,
        } 
      },
                   {
                     breakpoint: 768, 
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '60px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                     }
                   },
                   {
                     breakpoint: 479, 
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '30px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                     }
                   }
                  ]
    });
  }

  if($('#reviews-slider-2').length > 0) {
    $('#reviews-slider-2').slick({
      dots: false, 
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      arrows: true, 
      responsive: [{
        breakpoint: 998, 
        settings: { 
          slidesToShow: 3, 
          slidesToScroll: 1,
        } 
      },
                   {
                     breakpoint: 768, 
                     settings: {
                       infinite: true,
                       centerMode: false,
                       centerPadding: '60px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                     }
                   },
                   {
                     breakpoint: 479, 
                     settings: {
                       infinite: true,
                       centerMode: false,
                       centerPadding: '30px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                     }
                   }
                  ]
    });
  }

  // $('.header__search button').on('click',function() {
  //     $('.header__search-form').toggleClass('search-open'); 
  // }); 

  if($('.js-mobile-toggle').length > 0) {
    $('.js-mobile-toggle').on('click',function() {
      $(this).next('.footer__toogle-wrapper').slideToggle();
    });
  }

  var submitIcon = $('.header__search-icon');
  var inputBox = $('.header__search-input');
  var searchBox = $('.header__search');
  var isOpen = false;
  submitIcon.click(function(){
    if(isOpen == false){
      searchBox.addClass('searchbox-open');
      inputBox.focus();
      isOpen = true;
    } else {
      searchBox.removeClass('searchbox-open');
      inputBox.focusout();
      isOpen = false;
    }
  });  
  submitIcon.mouseup(function(){
    return false;
  });
  searchBox.mouseup(function(){
    return false;
  });
  $(document).mouseup(function(){
    if(isOpen == true){
      console.log('b');
      $('.header__search-icon').css('display','block');
      submitIcon.click();
    }
  });
  $(inputBox).on("keyup", function() {
    buttonUp();
  });

  if($(".header__toggle").length > 0) {
    $(".header__toggle").click(function(){
      $(this).toggleClass("is-active");
      $('.header__nav').toggleClass('open');
      $('body').toggleClass('menu-open');
    });
  }

  $('.header__list li.has-children > a').on('click',function(e){
    e.preventDefault(); 
    $(this).next('.header__submenu').slideToggle();
  });
$('#addToCart12').on('click',function(e) {
     $('#addToCart123')[0].click(); 
  })
})

function buttonUp(){
  var inputVal = $('.header__search-input').val();
  inputVal = $.trim(inputVal).length;
  if(inputVal !== 0){
    console.log('a');
    $('.header__search-icon').css('display','none'); 
  } else {
    $('.header__search-input').val('');
    $('.header__search-icon').css('display','block'); 
  }
}

/* scroll to target */
jQuery('.scrollTo').click(function (e) {
  var jump = jQuery(this).attr('href');
  var new_position = jQuery(jump).offset();
  var scroll = 20;
  jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function () {
    var new_position = jQuery(jump).offset();
    jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);
  });
  e.preventDefault();
});


  document.addEventListener('DOMContentLoaded', function (event) {
    
    $('.infoi').on('click',function(e) {
       $('.product-card').removeClass('active_popup'); 
       var id = $(this).closest('.product-card').data('id');
       $(this).closest('.product-container').find(id).addClass('active_popup');  
       $('body').addClass('parent_active_popup');
    })
    
    $('.close').on('click',function(e) {
      $('.juice_popup_wrapper').removeClass('active_popup'); 
      $('body').removeClass('parent_active_popup');
    })
    
    $('.more_info_title_desc .title').on('click',function(e) {
       $(this).next('.description').slideToggle(); 
    })
    
  })
